import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExtendedEvent } from './../../constants/types'

interface EventsState {
  newEventPosition: L.LatLng | null
  editEventPosition: L.LatLng | null
  selectedEvent: ExtendedEvent | null
  selectedEventId: number | null
  scrollTargetEventId: number
  currentEvents: ExtendedEvent[] | null
}

const initialState: EventsState = {
  newEventPosition: null,
  editEventPosition: null,
  selectedEvent: null,
  selectedEventId: null,
  scrollTargetEventId: 0,
  currentEvents: null,
}

export const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setNewEventPosition(state, action: PayloadAction<L.LatLng>) {
      state.newEventPosition = action.payload
    },
    setEditEventPosition(state, action: PayloadAction<L.LatLng | null>) {
      state.editEventPosition = action.payload
    },
    setSelectedEvent(state, action: PayloadAction<ExtendedEvent | null>) {
      state.selectedEvent = action.payload
    },
    setSelectedEventId(state, action: PayloadAction<number | null>) {
      state.selectedEventId = action.payload
    },
    setScrollTargetEventId(state, action: PayloadAction<number>) {
      state.scrollTargetEventId = action.payload
    },
    resetScrollTargetEventId(state) {
      state.scrollTargetEventId = 0
    },
    setCurrentEvents(state, action: PayloadAction<ExtendedEvent[] | null>) {
      state.currentEvents = action.payload
    },
    addCurrentEvent(state, action: PayloadAction<ExtendedEvent>) {
      state.currentEvents?.push(action.payload)
    },
    removeCurrentEvent(state, action: PayloadAction<number>) {
      state.currentEvents =
        state.currentEvents?.filter((cp) => cp.id !== action.payload) ?? null
    },
    updateCurrentEvent(state, action: PayloadAction<ExtendedEvent>) {
      const target = state.currentEvents?.filter(
        (cp) => cp.id !== action.payload.id
      )
      if (target) {
        state.currentEvents = [...target, action.payload]
      }
    },
  },
})

export const eventsActions = eventsSlice.actions
export const eventsReducer = eventsSlice.reducer
